import { connect } from "react-redux";

var CurrentUser =require ("lib/account/CurrentUser");
var QuestionTypes = require("lib/academic/QuestionTypes");

var RosterSelectors = require("lib/selectors/RosterSelectors");
var WritingSelectors = require("lib/selectors/WritingSelectors");
var WritingActions = require("lib/actions/WritingActions");
var AutograderDisplayConfig = require("lib/interface/AutograderDisplayConfig");
var NumbersOnlyInput = require("components/utility/NumbersOnlyInput");
var ReactionFeedback = require("components/support/ReactionFeedback");
var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");
var ButtonDropdown = require("components/utility/ButtonDropdown");
var RubricItemOverride = require("components/writing/evaluations/RubricItemOverride")

require("writing/controls/edit_controls.scss");

@connect(
	(state, props) => {
		var downProps = {}

		if (props.answerID) {
			downProps.evaluation = WritingSelectors.evaluationForSubject({
				state, subjectType: "Answer", subjectID: props.answerID
			});
		}

		if (props.quizID) {
			downProps.evaluation = WritingSelectors.evaluationForSubject({
				state, subjectType: "Quiz", subjectID: props.quizID
			});
		}

		if (props.quizID) {
			var quiz = WritingSelectors.quiz({ state, id: props.quizID });

			downProps.excluded = quiz.excluded;

			downProps.noun = "quiz";
		} else {
			var answer = WritingSelectors.answer({ state, id: props.answerID });

			downProps.excluded = answer.excluded;

			if (answer && answer.question_type == QuestionTypes.REVIEW_QUESTION) {
				downProps.noun = "review";
			} else {
				downProps.noun = "answer";
			}
		}

		if (CurrentUser.isStudent()) {
			var slPrefs = CurrentUser.get().prefs;
		} else {
			var slPrefs = RosterSelectors.studentListPrefs({ state }) || {};
		}
		downProps.displayScoreCap = slPrefs.display_score_cap;

		return downProps;
	}, 
	(dispatch, props) => {
		var handlers = {};

		if (props.answerID) {
			handlers.onDelete = () => dispatch(WritingActions.deleteAnswer({ id: props.answerID }))

			handlers.onInclude = () => dispatch(WritingActions.updateAnswer({
				id: props.answerID, update: { excluded: false }
			}));

			handlers.onExclude = () => dispatch(WritingActions.updateAnswer({
				id: props.answerID, update: { excluded: true }
			}));
		}

		if (props.quizID) {
			handlers.onDelete = () => dispatch(WritingActions.deleteQuiz({ id: props.quizID }))

			handlers.onInclude = () => dispatch(WritingActions.updateQuiz({
				id: props.quizID, update: { excluded: false }
			}));
			
			handlers.onExclude = () => dispatch(WritingActions.updateQuiz({
				id: props.quizID, update: { excluded: true }
			}));
		}

		handlers.onUpdate = (evaluationID, updateData) => {
			dispatch(WritingActions.updateEvaluation({ id: evaluationID, update: updateData }))
		}

		return handlers;
	}
)
class EditControls extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		if (props.evaluation && props.evaluation.ratio) {
			var editedScore = this.hideAutograderScore(props.evaluation) ? 0 : $wr.convertedScore(props.evaluation.ratio, props.displayScoreCap || 4);
		}

		this.state = { editedScore, showOverrideFeedback: false, rubricOverride: {} };
	}

	deleteAnswer(e) {
		$wr.nope(e)
		if (confirm("Are you sure you want to delete this " + this.props.noun + "?")) {
			window.wrNotifications.triggerDropDownNotification({
				title: "Deleted",
				text: "You have deleted the " + this.props.noun + ".",
				icon: "trash"
			});
			this.props.onDelete();
			if (this.props.afterDelete) {
				this.props.afterDelete()
			}
		}
	}

	includeAnswer(e) {
		$wr.nope(e)
		if (confirm("This will allow this " + this.props.noun + " to count toward your custom goals. Are you sure?")) {
			window.wrNotifications.triggerDropDownNotification({
				title: "Included",
				text: "You have included this " + this.props.noun + ".",
				icon: "ok-sign"
			});
			this.props.onInclude();
		}
	}
	excludeAnswer(e) {
		$wr.nope(e)
		if (confirm("This will exclude this " + this.props.noun + " from counting toward your custom goals. Are you sure?")) {
			window.wrNotifications.triggerDropDownNotification({
				title: "Excluded",
				text: "You have excluded this " + this.props.noun + ".",
				icon: "ok-sign"
			});
			this.props.onExclude();
		}
	}

	saveEvaluation(e) {
		$wr.nope(e)

		var originalEvaluation = this.props.evaluation;

		// Round up to the nearest 0.5
		var override = Math.round(this.state.editedScore * 2) / 2;

		var adminRatio = override / this.displayScoreCap();

		// Project this onto the scale of the original evaluation
		var adminScore = Math.ceil(adminRatio * originalEvaluation.score_cap);

		// set to 0 or score_cap if outside of 0-score_cap range
		if (adminScore < 0) {
			adminScore = 0;
			adminRatio = 0;
		} else if (adminScore > originalEvaluation.score_cap) {
			adminScore = originalEvaluation.score_cap;
			adminRatio = 1;
		}


		var scoreDetails = _.extend({}, originalEvaluation.score_details,
			{ admin_score: adminScore });

		// Included both score (for immediate display) and adminScore (for the API Patch)
		var updateData = {
			score: adminScore, ratio: adminRatio, admin_score: adminScore,
			score_details: scoreDetails, grader_id: this.props.graderID
		}

		// add read_book if updated
		if (!_.isEmpty(this.state.rubricOverride)) {
			updateData = { ...updateData, rubric_override: { ...this.state.rubricOverride } }
		}

		this.props.onUpdate(originalEvaluation.id, updateData);
		this.setState({ editingEvaluation: false, showOverrideFeedback: CurrentUser.isPremiumOrTrialAccount() });

		window.wrNotifications.triggerDropDownNotification({
			title: "Score Edited",
			text: "You have edited the score for this " + this.props.noun + ".",
			icon: "ok-sign"
		});

	}

	displayScoreCap(props) {
		return (props || this.props).displayScoreCap || 4;
	}

	convertedScore(ratio, props) {
		var score = ratio * this.displayScoreCap(props);
		// Round down to nearest 0.5
		score = Math.floor(score * 2) / 2;
		return score;
	}

	// extracts read book layer of polarizing hash
	getReadBookLeaf() {
		var { evaluation } = this.props
		var polarizing = evaluation && evaluation.autograder_data ? evaluation.autograder_data.polarizing : {}
		var leaves = AutograderDisplayConfig.getRubricLeaves(polarizing, false)
		if (!_.isEmpty(leaves) && _.has(leaves, READ_BOOK_RUBRIC_KEY)) {
			return { [READ_BOOK_RUBRIC_KEY]: leaves[READ_BOOK_RUBRIC_KEY] }
		}
	}

	// user is on a free account and hasn't manually graded answer
	hideAutograderScore(evaluation) {
		evaluation = evaluation ? evaluation : this.props.evaluation
		return !CurrentUser.isPremiumOrTrialAccount() && !evaluation.admin_score
	}

	handleRubricOverride(selectedOp) {
		this.setState({ rubricOverride: { [READ_BOOK_RUBRIC_KEY]: selectedOp } })
	}

	// allows teachers to edit rubric items
	renderRubricItemOverride() {
		if (this.props.evaluation.subject_type == 'Quiz') {
			return <RubricItemOverride view={'quizReadBook'} onChange={this.handleRubricOverride} leaves={this.getReadBookLeaf()} evaluation={this.props.evaluation} />
		}
	}

	// shows save button if admin has edited score or rubric item
	renderSaveButton() {
		var { editedScore, rubricOverride } = this.state
		var currentScore = this.hideAutograderScore() ? 0 : $wr.convertedScore(this.props.evaluation.ratio, this.props.displayScoreCap || 4);

		if (editedScore !== currentScore || !_.isEmpty(rubricOverride)) {
			return <button className="btn btn-link saveButton">Save</button>	
		 }
	}

	render() {
		if (this.props.evaluation && this.props.enabled.editScore) {			

			if (this.state.showOverrideFeedback) {
				var overrideFeedback = (
					<ReactionFeedback where="override-eval"
						textOnly={ true }
						textTitle="Our score was different than yours."
						placeholder="What did we miss? Why did you give it that score?"
						popover_position={ ReactionFeedback.POSITION_BOTTOM_LEFT }
						subjectType="Evaluation" subjectID={ this.props.evaluation.id } />
				);
			}

			var editScore = (
				<form onSubmit={ this.saveEvaluation } className="editRow">
					<div>
						<div>
							Edit Score: <NumbersOnlyInput className="form-control scoreEdit" allowDecimal
								value={this.state.editedScore} step={0.5}
								onChange={(e) => this.setState({ editedScore: parseFloat(e.target.value) })}
								max={this.displayScoreCap()} min={0} /> / {this.displayScoreCap()} 
						</div>
						<div className="readTheBookOverride">
							{this.renderRubricItemOverride()}
						</div>
						{this.renderSaveButton() }
					</div>
					{ overrideFeedback }
				</form>
			);
		}

		if (this.props.enabled.toggleInclude) {
			if (this.props.excluded) {
				var excludeIncludeToggle = (
					<div className="editRow">
						<a href="#" onClick={ this.includeAnswer }>
							Include In Goals
						</a>
					</div>
				);
			} else {
				var excludeIncludeToggle = (
					<div className="editRow">
						<a href="#" onClick={ this.excludeAnswer }>
							Exclude From Goals
						</a>
					</div>
				);
			}
		}

		if (this.props.enabled.deletion) {
			var deleteSubject = (
				<div className="editRow">
					<a href="#" onClick={ this.deleteAnswer }>
						Delete { $wr.capitalize(this.props.noun) }
					</a>
				</div>
			);
		}

		return (
			<div className="editControls">
				{ editScore }
				{ excludeIncludeToggle }
				{ deleteSubject }
			</div>
		)
	}
};

var READ_BOOK_RUBRIC_KEY = "crit-evi-cote-bert-read-book-1"

EditControls.propTypes = StrictPropTypes({
	answerID: PropTypes.number,
	quizID: PropTypes.number,

	// "enabled" keys used in *this (edit control)* component (others are ignored)
	//   editScore				-> Changes the score
	//   deletion 				-> Deletes the answer
	//   toggleInclude			-> Passed from answers -> controls
	//
	enabled: PropTypes.object,

	// From @connect
	onDelete: PropTypes.func,
	onRevert: PropTypes.func,
	onInclude: PropTypes.func,
	onExclude: PropTypes.func,
	onUpdate: PropTypes.func,
	afterDelete: PropTypes.func,
	noun: PropTypes.string,
	excluded: PropTypes.string,
});

module.exports = EditControls;



// WEBPACK FOOTER //
// ./modules/components/writing/controls/EditControls.js